export default {

    init() {
        this.footerMobileDropdown();
    },

    footerMobileDropdown() {
        $('.footer-mobile-drp-down .footer--title').on('click', function () {
            let parent = $(this).parent();
            if(parent.hasClass('active')){
                $('.footer-mobile-drp-down').removeClass('active');
                parent.find('.footer--links').slideUp(300);
            } else{
                $('.footer-mobile-drp-down').removeClass('active');
                parent.addClass('active');
                parent.find('.footer--links').slideDown(300);
            }
        });

    },
}